import React from 'react';

import { IoMailOpenOutline, IoLocationOutline } from "react-icons/io5";
import { MdAccessTime } from "react-icons/md";

import ContactInfoStyles from '../../styles/ContactUs/ContactInfo.module.css';

const ContactInfo = () => {
  return (
    <div className={ContactInfoStyles.infoSection}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '5px',
        borderRadius: '20px',
        backgroundColor: '#f0f2f5',
        width: '150px'
      }}>
        <div className={ContactInfoStyles.dot}></div> 
        <span className={ContactInfoStyles.powering}>
          Contact Info
        </span>
      </div>

      {/* Updated Heading */}
      <h2 className={ContactInfoStyles.title}>
        Have a <span className={ContactInfoStyles.red}>Project Idea ?</span><br /> Contact Us !
      </h2>

      <p className={ContactInfoStyles.desc}>
        Ready to take your logistics to the next level? Contact us today to
        discover how our tailored solutions and industry expertise can transform your supply chain.
      </p>

      {/* Email */}
      <div className={ContactInfoStyles.card}>
        <div className={ContactInfoStyles.cardInfo}>
          <IoMailOpenOutline className={ContactInfoStyles.icon} /> E-mail
        </div>
        <p className={ContactInfoStyles?.cardText}>hello@greenworks.co.in</p>
      </div>

      {/* Address */}
      <div className={ContactInfoStyles.card} style={{ marginTop: '10px' }}>
        <div className={ContactInfoStyles.cardInfo}>
          <IoLocationOutline className={ContactInfoStyles.icon} /> Address
        </div>
        <p className={ContactInfoStyles?.cardText}>
          New Delhi, India
        </p>
      </div>

      {/* Business Hours */}
      <div className={ContactInfoStyles.card} style={{ marginTop: '10px' }}>
        <div className={ContactInfoStyles.cardInfo}>
          <MdAccessTime className={ContactInfoStyles.icon} /> Business Hours
        </div>
        <p className={ContactInfoStyles?.cardText}>
          Monday – Friday, 9:00 AM – 6:00 PM
        </p>
      </div>
    </div>
  );
};

export default ContactInfo;
